<template>
  <div>
    <v-select
      v-model="model.numRows"
      hide-details
      :items="queryNum.Order"
      label="تعداد موارد"
    >
    </v-select>
  </div>
</template>
  <script>
  export default {
    name: "AbrQueryNumber",
    props: ["model"],
    data: () => ({
      queryNum: {
        Order: [
          { text: "10", value: 10 },
          { text: "20", value: 20 },
          { text: "30", value: 30 },
          { text: "50", value: 50 },
          { text: "1000", value: 1000 },
          { text: "همه", value:null  },
        ],
      },
    }),
  };
  </script>
  
  